import { dataHooks } from '@wix/data-hooks'

export const headlessBusinessNameDataHooks = dataHooks<{
  next: {}
  template: {}
  input: {}
}>('headless-business-name')
